import {
  call, put, takeEvery
} from "redux-saga/effects";
import {
  FETCH_IP_BLOCKS_START,
  ADD_IP_BLOCK_START,
  DELETE_IP_BLOCK_START,
} from "./actionTypes";
import {
  fetchIpBlocksSuccess, fetchIpBlocksError, addIpBlockSuccess, addIpBlockError, addIpBlockClear, deleteIpBlockDone
} from "./actions";
import { showErrorNotification, showSuccessNotification } from "store/notifications/actions";

import * as ipAccessControlApi from "../../apis/ipAccessControl";

function * fetchIpBlocks(params) {
  try {
    const data = yield call(ipAccessControlApi.getBlockedIps, params);
    yield put(fetchIpBlocksSuccess(data));
  }
  catch (error) {
    yield put(fetchIpBlocksError(error));
  }
}

function * addIpBlock(params) {
  try {
    const data = yield call(ipAccessControlApi.addBlock, params);
    const { result } = data;
    yield put(addIpBlockSuccess(result));
    yield put(showSuccessNotification("IP blocked successfully"));
    yield put(addIpBlockClear());
  }
  catch (error) {
    yield put(addIpBlockError(error));
  }
}

function * deleteIpBlock(params) {
  try {
    const data = yield call(ipAccessControlApi.deleteBlock, params);
    const { result } = data;
    yield put(deleteIpBlockDone({
      result,
      ip: params.payload
    }));
    yield put(showSuccessNotification("IP unblocked successfully"));
  }
  catch (error) {
    yield put(deleteIpBlockDone({ error: error.message }));
    yield put(showErrorNotification(error.message));
  }
}

function* ipAccessControlSaga() {
  yield takeEvery(FETCH_IP_BLOCKS_START, fetchIpBlocks);
  yield takeEvery(ADD_IP_BLOCK_START, addIpBlock);
  yield takeEvery(DELETE_IP_BLOCK_START, deleteIpBlock);
}

export default ipAccessControlSaga;
